<script setup>
import { onMounted, ref } from 'vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import { Toaster } from '@/models/utils/Toaster.js'
import InputText from '@/components/Forms/InputText.vue'
import { userApi } from '@/api/User/UserApi.js'
import { useAuthStore } from '@/stores/authStore.js'
import LoadingSpinner from '@/components/Spinners/LoadingSpinner.vue'

const tenantSettings = ref(null)
const archiveAfterDays = ref(365)
const archiveAfterDaysDescription = ref(null)
const isSaving = ref(false)
const isLoading = ref(false)
const toaster = new Toaster()

onMounted(() => {
	isLoading.value = true

	userApi.getTenantById(useAuthStore().getAuth.user().tenant_id, (tenantData) => {
		tenantSettings.value = JSON.parse(tenantData.settings_json)
		archiveAfterDays.value = tenantSettings.value.data_submissions_archive_after_days?.value ?? 365
		archiveAfterDaysDescription.value = tenantSettings.value.data_submissions_archive_after_days?.description ??
			"Data submissions are considered \"archived\" after this many days:"

		isLoading.value = false
	})
});

function updateArchiveDays() {
	const settings = {
		'data_submissions_archive_after_days': archiveAfterDays.value
	}

	isSaving.value = true
	userApi.updateTenantSettings({ settings: settings },
		() => {
			isSaving.value = false
			toaster.success('Settings successfully updated!')

			userApi.refreshUserData()
		}, (e) => {
			toaster.error(e.showErrorBanner())
			isSaving.value = false
		})
}

</script>

<template>
	<AdminLayout>
		<p class="admin-center-subtitle">Data Submissions Settings</p>

		<div v-if="!isLoading" class="flex mt-4 mb-2 space-x-4">
			<span class="h-fit my-auto">{{ archiveAfterDaysDescription }}</span>
			<InputText class="max-w-15.5 !mb-0" v-model="archiveAfterDays" :max-length="3" placeholder="" input-height="h-10" :disabled="isLoading"/>
			<SubmitButton label="Update" @click="updateArchiveDays" size="extra-small" :loading="isLoading || isSaving" :disabled="isLoading || isSaving"/>
		</div>
		<div v-else class="flex mt-4 mb-4 space-x-4">
			<LoadingSpinner class="!p-0" size="24"/>
			<span class="font-medium">Loading settings...</span>
		</div>
	</AdminLayout>
</template>